export default __webpack_public_path__ + "static/media/jee_icon2.d11e2b05.svg";